import { createBrowserRouter, createRoutesFromElements, Route } from "react-router-dom";
import TestSelection from "../pages/TestSelection";
import TestPage from "../pages/TestPage";
import TokenGuard from "../pages/TokenGuard";
import NotFound from "./NotFound";
import ResultPage from "../pages/ResultPage";
import MainLayout from "./MainLayout";
import About from "./About";

const Routes = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<MainLayout />}>
      <Route exact path="/" element={<TokenGuard><TestSelection /></TokenGuard>} />
      <Route path="/ssc-er" element={<TokenGuard><TestPage /></TokenGuard>} />
      <Route path="/ssc-sd" element={<TokenGuard><TestPage /></TokenGuard>} />
      <Route path="/bcl" element={<TokenGuard><TestPage /></TokenGuard>} />
      <Route path="/cat" element={<TokenGuard><TestPage /></TokenGuard>} />
      <Route path="/results" element={<TokenGuard><ResultPage /></TokenGuard>} />
      <Route path="/page-not-found" element={<NotFound />} />
      <Route path="/about" element={<TokenGuard><About /></TokenGuard>} />
      <Route path="*" element={<NotFound />} />
    </Route>
  ),
  {
    basename: process.env.REACT_APP_URL,
  }
)

export default Routes;